import React, { useState } from "react";
import MainCalculatorsList from './MainCalculators';
import RelatedLinks from '../RelatedLinks';
import MoneyZakatTable from './MoneyZakatTable';
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Money_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = `حساب زكاة المال 2026 - حاسبة نصاب زكاة المال`;
const DESCRIPTION = 'حاسبة زكاة المال هي أداة تستخدم ل حساب الزكاة المال ونصاب زكاة المال على الأموال النقدية والمدخرات والاستثمارات.';
const KEYWORDS = 'زكاة لمال, مقدار زكاة المال, نصاب الزكاة, الزكاة على المال, حاسبة زكاة المال, زكاة, حساب زكاة المال, نصاب زكاة المال';
const OG_URL = 'https://do-calculate.com/calculator/ar/money-zakat/';
const apiEndpoint = `${SERVER_URL}/${Money_Zakat_EndPoint}`;
function MoneyZakatCalculator() {
    const [amount, setAmount] = useState('');
    const [yearType, setYearType] = useState('');
    const [gramPriceGold, setGramPriceGold] = useState(0);
    const [gramPriceSilver, setGramPriceSilver] = useState(0);
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const [thresholdType, setThresholdType] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const handleThresholdTypeChange = (event) => {
        const newThresholdType = event.target.value;
        setThresholdType(newThresholdType);
        if (newThresholdType === "gold") {
            setGramPriceSilver(0);
        } else if (newThresholdType === "silver") {
            setGramPriceGold(0);
        }
    };
    const handleYearTypeChange = (event) => {
        setYearType(event.target.value);
    };
    const handleAmountChange = (event) => {
        setAmount(event.target.value);
    };
    const handleGramPriceGoldChange = (event) => {
        setGramPriceGold(event.target.value);
    };
    const handleGramPriceSilverChange = (event) => {
        setGramPriceSilver(event.target.value);
    };
    const calculateMoneyZakat = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ amount, yearType, gramPriceGold, gramPriceSilver }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
                setClassification(data.result.classification);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="rtl">
            <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '15px' }}>احسب زكاة المال</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                حاسبة زكاة المال هي أداة تستخدم لحساب مبلغ الزكاة المستحقة على الأموال النقدية والمدخرات والاستثمارات وحساب نصاب زكاة المال ومقدار زكاة المال الواجب اخراجها. تم تصميم الحاسبة بحيث تأخذ في الاعتبار قيمة المال المملوك ونوع السنة الزمنية (هجري أو ميلادي) وأسعار الذهب والفضة لحساب الحد الأدنى للمال المستحق للزكاة
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}>حاسبة زكاة المال</h2>
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >نوع الحول</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="gregorianRadio"
                                            name="yearType"
                                            value="gregorian"
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorianRadio">
                                            ميلادي
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="hijri"
                                            name="yearType"
                                            value="hijri"
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            هجري
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="amoutNumber" className="form-label ms-2" >إجمالي المال</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="amoutNumber"
                                        value={amount}
                                        onChange={handleAmountChange}
                                        className="form-control ml-2"
                                        style={{ width: '150px' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label >نوع النصاب</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="gold"
                                            name="thresholdType"
                                            value="gold"
                                            checked={thresholdType === "gold"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gold">
                                            ذهب
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="silver"
                                            name="thresholdType"
                                            value="silver"
                                            checked={thresholdType === "silver"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="silver">
                                            فضة
                                        </label>
                                    </div>
                                </div>
                                <br />
                                {thresholdType === "gold" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceSilver == 0}
                                        <b>
                                            <label className="form-label ms-2">سعر غرام الذهب (24 قيراط)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceGoldNumber"
                                            value={gramPriceGold}
                                            onChange={handleGramPriceGoldChange}
                                            className="form-control ml-2"
                                            style={{ width: '150px' }}
                                        />
                                    </div>
                                )}
                                {thresholdType === "silver" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceGold == 0}
                                        <b>
                                            <label className="form-label ms-2">سعر غرام الفضة (عيار 99.9)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceSilverNumber"
                                            value={gramPriceSilver}
                                            onChange={handleGramPriceSilverChange}
                                            className="form-control ml-2"
                                            style={{ width: '150px' }}
                                        />
                                    </div>
                                )}
                                <br/>                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateMoneyZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'إحسب'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> حدث خطأ :</u></b> يُرجى إدخال جميع الحقول بالشكل الصحيح. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">النتائج: </div></h4>
                                            <hr />
                                            <MoneyZakatTable result={result}></MoneyZakatTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">وصف حاسبة زكاة المال</div>
                            <div className="info-section-body">
                                <div>
                                    <h2 style={{ fontSize: '15px' }}>نصاب زكاة المال - مقدار الزكاة الواجبة</h2>
                                    <p>
                                        تعتمد حاسبة زكاة المال على حساب نصاب الزكاة وفقًا للمعايير الشرعية الإسلامية. على سبيل المثال، في الزكاة الهجرية، يجب أن يكون النصاب مالاً يعادل قيمته 85 جرامًا من الذهب، وفي الزكاة الميلادية، يكون النصاب مالاً يعادل قيمته 595 جرامًا من الفضة. إذا كانت قيمة المال الذي تمتلكه تتجاوز هذا النصاب، فإنه يجب عليك إخراج الزكاة.
                                    </p>
                                    <br />
                                    <h2 style={{ fontSize: '15px' }}>طريقة حساب زكاة المال</h2>
                                    <p>
                                        تقوم الحاسبة بحساب مقدار الزكاة المستحقة بناءً على القيم المدخلة من قبل المستخدم، وفقًا لأحكام الشريعة الإسلامية. إذا تجاوزت قيمة المال النصاب المحدد حسب السنة الزمنية وأسعار الذهب أو الفضة، تقوم الحاسبة بحساب نسبة الزكاة المقررة، والتي تبلغ 2.5% للزكاة الهجرية و2.577% للزكاة الميلادية. بعد ذلك، تحدد حالة الزكاة إذا كانت مستحقة ("نعم") وتحسب المبلغ المالي الواجب دفعه.
                                    </p>
                                    <p>
                                        تقدم الحاسبة نتائجها في شكل تقرير يشمل حالة الزكاة ("نعم" أو "لا")، والمبلغ المستحق، وأدنى قيمة للمال تجب فيه الزكاة.
                                    </p>
                                    <br />
                                    <div className='p-3 mb-2 bg-info'>
                                    الذهب المعتبر في تحديد نصاب الزكاة هو عيار 24؛ لأن عيار 21، أو 18 ليس ذهبًا صافيًا، بل هو مخلوط بفلزات، ومعادن أخرى. فمن كان عنده عيار آخر من ذهب 22 أو 21 أو 18 أو 14 أو 10 أو غيرهما، فالزكاة تجب في الصافي منه فقط.
                                    </div>
                                    <p>
                                        هذه الحاسبة قابلة للاستخدام في جميع الدول العربية، بما في ذلك:
                                    </p>
                                    <ul>
                                        <li>المملكة العربية السعودية</li>
                                        <li>الإمارات العربية المتحدة</li>
                                        <li>الكويت</li>
                                        <li>البحرين</li>
                                        <li>قطر</li>
                                        <li>عمان</li>
                                        <li>الأردن</li>
                                        <li>مصر</li>
                                        <li>العراق</li>
                                        <li>لبنان</li>
                                        <li>سوريا</li>
                                        <li>فلسطين</li>
                                        <li>اليمن</li>
                                        <li>المغرب</li>
                                        <li>الجزائر</li>
                                        <li>تونس</li>
                                        <li>ليبيا</li>
                                    </ul>
                                    <br />
                                    <hr />
                                    <b>المصدر: </b>
                                    <a href="https://www.islamic-relief.me/%D8%AD%D8%B3%D8%A7%D8%A8-%D8%B2%D9%83%D8%A7%D8%A9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/" rel="nofollow noreferrer" target="_blank">
                                        الإغاثة الإسلامية عبر العالم
                                    </a>
                                    <br />
                                    <b>تاريخ آخر مراجعة:</b> 28/02/2026
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default MoneyZakatCalculator;
